import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  FormControl,
  InputLabel,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const CreateNewPeriodModel = ({ onClose, onSuccess }) => {
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [formData, setFormData] = useState();

  // Add useEffect to handle initial data
  /*   useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData?.id || null, // Add ID field
        code: initialData?.code || null,
        type: initialData?.type || null,
        name: initialData?.name || null,
        balance: initialData?.balance || 0,
        is_current: initialData?.is_current || null,
        parent_id: initialData?.parent_id || null,
      });
    }
  }, [initialData]); */
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formSubmitted]);

  const validateForm = () => {
    const newErrors = {};

    // if (!validateRequired(formData.code)) newErrors.store_id)) newErrors.store_id = "يجب إدخال المتجر"; // if (!validateRequired(formData.code = "يجب إدخال كود العملة مثل SAR";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          formPayload.append(key, value);
        }
      });

      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `https://back.al-balad.sa/albalad/v1.0/accounting/accounts/update/${formData.id}`
        : "https://back.al-balad.sa/albalad/v1.0/accounting/fiscal-periods/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // Close loading indicator
      Swal.close();

      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";

      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({});
    setErrors({});
    onClose();
  };
  return (
    <Box
      sx={{
        p: 3,
        width: "100%",
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          اضافة فترة جديدة
        </Typography>
      </Box>

      {/* Main Form */}
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth error={!!errors.code} sx={{ mb: 2 }}>
          <TextField
            type="text"
            name="name"
            label="اسم الفترة"
            value={formData?.name ? formData?.name :null}
            onChange={handleChange}
            required
            
            fullWidth
          />
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="is_current">حالة الفترة </InputLabel>
          <Select
            labelId="activing"
            label="حالة "
            name="is_current"
            value={Boolean(formData?.is_current) || null}
            onChange={handleChange}
            sx={{ height: 43 }}
          >
            <MenuItem value="true">حالية</MenuItem>
            <MenuItem value="false">منتهية</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth error={!!errors.code} sx={{ mb: 2 }}>
          <TextField
            type="date"
            name="start_date"
            label="تاريخ البداية"
            value={formData?.start_date || ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </FormControl>

        <FormControl fullWidth error={!!errors.code} sx={{ mb: 2 }}>
          <TextField
            type="date"
            name="end_date"
            label="تاريخ النهاية"
            value={formData?.end_date || ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </FormControl>
      </Box>
      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="text.main">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="outlined" color="text" onClick={handleCancel} sx={{ px: 4 , color:"text.main" ,borderColor:"text.border" }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="default"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important", bgcolor: "primary.dark" ,"&:hover": { bgcolor: "primary.main" } }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>

    /* </Dialog> */
  );
};

export default CreateNewPeriodModel;
